module.exports = __webpack_public_path__ + "img/symbols_2.ab121959.svg";